"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceUserContextMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const lucide_react_1 = require("lucide-react");
const useStore_1 = require("../store/useStore");
const VoiceService_1 = require("../services/VoiceService");
const VoiceUserContextMenu = ({ user, position, onClose, channelId, isLocal = false, }) => {
    const menuRef = (0, react_1.useRef)(null);
    const targetUserId = String(user.userId || user.id);
    const { currentUser, setSelectedUser, setSelectedDMUser, currentServerMembers, selectedServerId, servers } = (0, useStore_1.useStore)();
    const [copied, setCopied] = (0, react_1.useState)(false);
    const [userVolume, setUserVolume] = (0, react_1.useState)(() => {
        const saved = localStorage.getItem(`meci_user_vol_${targetUserId}`);
        return saved ? Number(saved) : 100;
    });
    const [isMutedLocally, setIsMutedLocally] = (0, react_1.useState)(() => {
        return localStorage.getItem(`meci_user_muted_${targetUserId}`) === 'true';
    });
    const [isDeafenedLocally, setIsDeafenedLocally] = (0, react_1.useState)(() => {
        return localStorage.getItem(`meci_user_deaf_${targetUserId}`) === 'true';
    });
    const [isVideoDisabledLocally, setIsVideoDisabledLocally] = (0, react_1.useState)(() => {
        return localStorage.getItem(`meci_user_videodisable_${targetUserId}`) === 'true';
    });
    const [serverMuted, setServerMuted] = (0, react_1.useState)(false);
    const [serverDeafened, setServerDeafened] = (0, react_1.useState)(false);
    // Determine if current user has moderation rights on this server
    const currentServer = servers?.find((s) => s.id === selectedServerId);
    const isOwner = currentServer && String(currentServer.owner_id || currentServer.ownerId) === String(currentUser?.id);
    const myMember = currentServerMembers?.find((m) => String(m.id || m.userId || m.user_id) === String(currentUser?.id));
    const canModerate = isOwner || myMember?.role === 'admin' || myMember?.role === 'moderator';
    // Position adjustments to prevent overflowing window bounds
    const [adjustedPos, setAdjustedPos] = (0, react_1.useState)(position);
    (0, react_1.useEffect)(() => {
        if (menuRef.current) {
            const rect = menuRef.current.getBoundingClientRect();
            let x = position.x;
            let y = position.y;
            if (x + rect.width > window.innerWidth) {
                x = window.innerWidth - rect.width - 12;
            }
            if (y + rect.height > window.innerHeight) {
                y = window.innerHeight - rect.height - 12;
            }
            setAdjustedPos({ x: Math.max(10, x), y: Math.max(10, y) });
        }
    }, [position]);
    // Click outside and escape handler
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };
        const handleKeyDown = (e) => {
            if (e.key === 'Escape')
                onClose();
        };
        window.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose]);
    // Handle local user volume slider change (%0 to %200 boost)
    const handleVolumeChange = (newVol) => {
        setUserVolume(newVol);
        localStorage.setItem(`meci_user_vol_${targetUserId}`, String(newVol));
        if (isMutedLocally && newVol > 0) {
            setIsMutedLocally(false);
            localStorage.setItem(`meci_user_muted_${targetUserId}`, 'false');
        }
        VoiceService_1.voiceService.setRemoteVolume(targetUserId, isMutedLocally ? 0 : newVol);
    };
    // Toggle local mute
    const handleToggleLocalMute = () => {
        const nextMuted = !isMutedLocally;
        setIsMutedLocally(nextMuted);
        localStorage.setItem(`meci_user_muted_${targetUserId}`, String(nextMuted));
        VoiceService_1.voiceService.setRemoteVolume(targetUserId, nextMuted ? 0 : userVolume);
    };
    // Toggle local deafen
    const handleToggleLocalDeafen = () => {
        const nextDeafen = !isDeafenedLocally;
        setIsDeafenedLocally(nextDeafen);
        localStorage.setItem(`meci_user_deaf_${targetUserId}`, String(nextDeafen));
        VoiceService_1.voiceService.setRemoteVolume(targetUserId, nextDeafen ? 0 : userVolume);
    };
    // Toggle disable video
    const handleToggleVideoDisable = () => {
        const nextVal = !isVideoDisabledLocally;
        setIsVideoDisabledLocally(nextVal);
        localStorage.setItem(`meci_user_videodisable_${targetUserId}`, String(nextVal));
        const videoCard = document.getElementById(`video-card-${targetUserId}`);
        if (videoCard) {
            const vid = videoCard.querySelector('video');
            if (vid)
                vid.style.display = nextVal ? 'none' : 'block';
        }
    };
    // Copy User ID
    const handleCopyId = () => {
        navigator.clipboard.writeText(targetUserId);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
            onClose();
        }, 900);
    };
    // Mention user in chat
    const handleMention = () => {
        const input = document.querySelector('.chat-input, .message-input');
        if (input) {
            const mentionText = `@${user.displayName || user.username || targetUserId} `;
            input.value = (input.value || '') + mentionText;
            input.focus();
        }
        onClose();
    };
    // Send Direct Message
    const handleSendMessage = () => {
        setSelectedDMUser(targetUserId);
        onClose();
    };
    // View Profile
    const handleViewProfile = () => {
        setSelectedUser(targetUserId);
        onClose();
    };
    // Server Mute / Deafen / Kick (Remote Moderation)
    const handleServerMute = () => {
        const nextState = !serverMuted;
        setServerMuted(nextState);
        VoiceService_1.voiceService.sendAdminModeration(targetUserId, targetUserId, 'mute', nextState);
    };
    const handleServerDeafen = () => {
        const nextState = !serverDeafened;
        setServerDeafened(nextState);
        VoiceService_1.voiceService.sendAdminModeration(targetUserId, targetUserId, 'deafen', nextState);
    };
    const handleServerKick = () => {
        if (window.confirm(`${user.displayName} kullanıcısını ses kanalından atmak istediğinize emin misiniz?`)) {
            VoiceService_1.voiceService.sendAdminModeration(targetUserId, targetUserId, 'kick');
            onClose();
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { ref: menuRef, className: "voice-user-context-menu", style: {
            position: 'fixed',
            top: adjustedPos.y,
            left: adjustedPos.x,
            zIndex: 999999,
            background: '#111214',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '8px',
            padding: '6px',
            width: '230px',
            boxShadow: '0 12px 32px rgba(0, 0, 0, 0.75)',
            color: '#dbdee1',
            fontFamily: 'Inter, sans-serif',
            userSelect: 'none',
            animation: 'contextMenuFadeIn 0.12s ease-out',
        }, onClick: (e) => e.stopPropagation(), children: [(0, jsx_runtime_1.jsxs)("div", { style: {
                    padding: '6px 8px 8px',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
                    marginBottom: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }, children: [user.avatar ? ((0, jsx_runtime_1.jsx)("img", { src: user.avatar, alt: "", style: { width: '22px', height: '22px', borderRadius: '50%', objectFit: 'cover' } })) : ((0, jsx_runtime_1.jsx)("div", { style: { width: '22px', height: '22px', borderRadius: '50%', background: '#5865f2', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: 700 }, children: user.displayName.charAt(0).toUpperCase() })), (0, jsx_runtime_1.jsxs)("div", { style: { flex: 1, minWidth: 0 }, children: [(0, jsx_runtime_1.jsx)("div", { style: { fontSize: '13px', fontWeight: 700, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, children: user.displayName }), isLocal && (0, jsx_runtime_1.jsx)("span", { style: { fontSize: '10px', color: '#57f287' }, children: "Siz (Yerel)" })] })] }), (0, jsx_runtime_1.jsxs)("button", { className: "v-ctx-item", onClick: handleViewProfile, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.User, { size: 15 }), (0, jsx_runtime_1.jsx)("span", { children: "Profil" })] }), (0, jsx_runtime_1.jsxs)("button", { className: "v-ctx-item", onClick: handleMention, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.AtSign, { size: 15 }), (0, jsx_runtime_1.jsx)("span", { children: "Bahset" })] }), !isLocal && ((0, jsx_runtime_1.jsxs)("button", { className: "v-ctx-item", onClick: handleSendMessage, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.MessageSquare, { size: 15 }), (0, jsx_runtime_1.jsx)("span", { children: "Mesaj G\u00F6nder" })] })), (0, jsx_runtime_1.jsx)("div", { style: { height: '1px', background: 'rgba(255, 255, 255, 0.06)', margin: '4px 0' } }), !isLocal && ((0, jsx_runtime_1.jsxs)("div", { style: { padding: '8px 8px 10px' }, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }, children: [(0, jsx_runtime_1.jsx)("span", { style: { fontSize: '11px', fontWeight: 700, color: '#94a3b8' }, children: "Kullan\u0131c\u0131 Ses Seviyesi" }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center', gap: '4px' }, children: [(0, jsx_runtime_1.jsxs)("span", { style: { fontSize: '12px', fontWeight: 800, color: userVolume > 100 ? '#57f287' : '#fff' }, children: ["%", isMutedLocally ? 0 : userVolume] }), userVolume > 100 && ((0, jsx_runtime_1.jsx)("span", { style: { fontSize: '8px', fontWeight: 800, color: '#57f287', background: 'rgba(87, 242, 135, 0.15)', padding: '1px 4px', borderRadius: '3px' }, children: "BOOST" }))] })] }), (0, jsx_runtime_1.jsx)("input", { type: "range", min: "0", max: "200", value: isMutedLocally ? 0 : userVolume, onChange: (e) => handleVolumeChange(Number(e.target.value)), style: {
                            width: '100%',
                            height: '5px',
                            cursor: 'pointer',
                            accentColor: userVolume > 100 ? '#57f287' : '#5865f2',
                        } }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', justifyContent: 'space-between', fontSize: '9px', color: '#64748b', marginTop: '3px' }, children: [(0, jsx_runtime_1.jsx)("span", { children: "%0" }), (0, jsx_runtime_1.jsx)("span", { children: "%100" }), (0, jsx_runtime_1.jsx)("span", { style: { color: '#57f287' }, children: "%200" })] })] })), !isLocal && ((0, jsx_runtime_1.jsxs)("label", { className: "v-ctx-checkbox-item", onClick: handleToggleLocalMute, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center', gap: '8px' }, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.VolumeX, { size: 15, style: { color: isMutedLocally ? '#ed4245' : '#94a3b8' } }), (0, jsx_runtime_1.jsx)("span", { children: "Sustur" })] }), (0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: isMutedLocally, onChange: () => { }, style: { cursor: 'pointer', accentColor: '#5865f2' } })] })), !isLocal && ((0, jsx_runtime_1.jsxs)("label", { className: "v-ctx-checkbox-item", onClick: handleToggleLocalDeafen, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center', gap: '8px' }, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Headphones, { size: 15, style: { color: isDeafenedLocally ? '#ed4245' : '#94a3b8' } }), (0, jsx_runtime_1.jsx)("span", { children: "Sa\u011F\u0131rla\u015Ft\u0131r" })] }), (0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: isDeafenedLocally, onChange: () => { }, style: { cursor: 'pointer', accentColor: '#5865f2' } })] })), !isLocal && ((0, jsx_runtime_1.jsxs)("label", { className: "v-ctx-checkbox-item", onClick: handleToggleVideoDisable, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center', gap: '8px' }, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.VideoOff, { size: 15, style: { color: isVideoDisabledLocally ? '#ed4245' : '#94a3b8' } }), (0, jsx_runtime_1.jsx)("span", { children: "G\u00F6r\u00FCnt\u00FCy\u00FC devre d\u0131\u015F\u0131 b\u0131rak" })] }), (0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: isVideoDisabledLocally, onChange: () => { }, style: { cursor: 'pointer', accentColor: '#5865f2' } })] })), canModerate && !isLocal && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { style: { height: '1px', background: 'rgba(255, 255, 255, 0.06)', margin: '4px 0' } }), (0, jsx_runtime_1.jsx)("div", { style: { fontSize: '9px', fontWeight: 800, color: '#f59e0b', padding: '4px 8px 2px', letterSpacing: '0.5px' }, children: "Y\u00D6NET\u0130C\u0130 MODERASYONU" }), (0, jsx_runtime_1.jsxs)("label", { className: "v-ctx-checkbox-item", onClick: handleServerMute, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center', gap: '8px' }, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.MicOff, { size: 14, style: { color: serverMuted ? '#ed4245' : '#94a3b8' } }), (0, jsx_runtime_1.jsx)("span", { style: { color: serverMuted ? '#ed4245' : '#dbdee1' }, children: "Sunucuda Sustur" })] }), (0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: serverMuted, onChange: () => { }, style: { cursor: 'pointer', accentColor: '#ed4245' } })] }), (0, jsx_runtime_1.jsxs)("label", { className: "v-ctx-checkbox-item", onClick: handleServerDeafen, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center', gap: '8px' }, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Headphones, { size: 14, style: { color: serverDeafened ? '#ed4245' : '#94a3b8' } }), (0, jsx_runtime_1.jsx)("span", { style: { color: serverDeafened ? '#ed4245' : '#dbdee1' }, children: "Sunucuda Sa\u011F\u0131rla\u015Ft\u0131r" })] }), (0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: serverDeafened, onChange: () => { }, style: { cursor: 'pointer', accentColor: '#ed4245' } })] }), (0, jsx_runtime_1.jsxs)("button", { className: "v-ctx-item danger", onClick: handleServerKick, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.UserX, { size: 15 }), (0, jsx_runtime_1.jsx)("span", { children: "Odadan \u00C7\u0131kar (Kick)" })] })] })), (0, jsx_runtime_1.jsx)("div", { style: { height: '1px', background: 'rgba(255, 255, 255, 0.06)', margin: '4px 0' } }), (0, jsx_runtime_1.jsxs)("button", { className: "v-ctx-item", onClick: handleCopyId, children: [copied ? (0, jsx_runtime_1.jsx)(lucide_react_1.Check, { size: 15, style: { color: '#57f287' } }) : (0, jsx_runtime_1.jsx)(lucide_react_1.Copy, { size: 15 }), (0, jsx_runtime_1.jsx)("span", { children: copied ? 'Kopyalandı!' : "Kullanıcı ID'sini Kopyala" })] }), (0, jsx_runtime_1.jsx)("style", { children: `
        @keyframes contextMenuFadeIn {
          from { opacity: 0; transform: scale(0.96); }
          to { opacity: 1; transform: scale(1); }
        }
        .v-ctx-item {
          display: flex;
          align-items: center;
          gap: 10px;
          width: 100%;
          padding: 8px 10px;
          background: transparent;
          border: none;
          color: #dbdee1;
          font-size: 13px;
          border-radius: 4px;
          cursor: pointer;
          text-align: left;
          transition: background 0.12s ease, color 0.12s ease;
        }
        .v-ctx-item:hover {
          background: #5865f2;
          color: white;
        }
        .v-ctx-item.danger:hover {
          background: #da373c;
          color: white;
        }
        .v-ctx-checkbox-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 10px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 13px;
          color: #dbdee1;
          transition: background 0.12s ease;
        }
        .v-ctx-checkbox-item:hover {
          background: rgba(255, 255, 255, 0.05);
        }
      ` })] }));
};
exports.VoiceUserContextMenu = VoiceUserContextMenu;
